import React from 'react';

const CloseIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 40 40"
      {...props}
    >
      <circle cx="20" cy="20" r="20" fill="var(--close-icon-bg, none)" />
      <path
        fill="var(--close-icon, #969799)"
        d="M21.008 19.774l5.926-5.926a.872.872 0 00-1.234-1.233l-5.926 5.926-5.926-5.926a.872.872 0 00-1.233 1.233l5.926 5.926-5.926 5.927a.873.873 0 101.234 1.234l5.925-5.927 5.926 5.926a.873.873 0 001.234-1.234z"
      />
    </svg>
  );
};

export default CloseIcon;
